import { Grid, Chip } from '@material-ui/core'
import React, {useState} from 'react'
import SimpleCard from '../../../../components/Structure/Cards/SimpleCard'
import DisplayText from '../../../../components/Texts/DisplayText'
import SearchSegments from '../forms/SearchSegments'
import AddSegmentModal from '../modals/AddSegmentModal'
import { request_create_product_segment, request_delete_product_segment } from '../requests'
import { translations as translations_esp } from '../../../../texts/esp/product-translations'


const Segments = ({id, product_segments, onUpdateCompleted, product_subcategories}) => {

    const content = translations_esp.segments

    const [add_modal, setAddModal] = useState(false)

    const onDeleteItem = async(el) => {
        await request_delete_product_segment(el)
        onUpdateCompleted()
    }

    const onAddProductItem = async (el) => {
        try {
            await request_create_product_segment({product_id:id, segment_id:el});
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
        }
    }

    return(
        <SimpleCard>
        <AddSegmentModal open={add_modal} onClose={()=>setAddModal(false)} onUpdateCompleted={onUpdateCompleted} 
        onAddProductItem={onAddProductItem} content={content.modal}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>                 
                    <DisplayText variant='subtitle1'>{content.title}</DisplayText>                
                </Grid>
                <Grid item xs={12}>
                    <SearchSegments onAddItem={()=>setAddModal(true)} existingItems={product_segments} 
                    onAddProductItem={onAddProductItem} content={content.search_bar} 
                    product_subcategories={product_subcategories}/>
                </Grid>
                <Grid item xs={12} >
                    <Grid container spacing={1}>
                        {product_segments.map((item, index)=>{
                            return(
                                <Grid item key={index}>
                                    <Chip label={item.segment} onDelete={()=>onDeleteItem(item.id_product_segment)} />
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
            </Grid>      
        </SimpleCard>
    )
}

export default Segments